import { createReducer, on, Action } from '@ngrx/store';

import { INITIAL_STATE, UserConfigurationState } from './user-configuration.declarations';
import * as UserConfigurationActions from './user-configuration.actions';

const reducer = createReducer<UserConfigurationState>(
  INITIAL_STATE,
  /** init */
  on(UserConfigurationActions.featureInitSuccess, (state, { userConfiguration }) => ({
    ...state,
    userConfigurationId: userConfiguration.userConfigurationId,
    calendarConfiguration: userConfiguration.calendarConfiguration,
    externalProvidersConfiguration: userConfiguration.externalProvidersConfiguration
  })),
  on(UserConfigurationActions.featureInitError, state => ({ ...state })),
  /** calendar config */
  on(
    UserConfigurationActions.updateViaCalendarConfiguration,
    (state, { calendarConfiguration }) => ({
      ...state,
      calendarConfiguration
    })
  ),
  on(UserConfigurationActions.updateCalendarConfiguration, (state, { userConfiguration }) => ({
    ...state,
    calendarConfiguration: userConfiguration.calendarConfiguration
  }))
);

/** save */
export function userConfigurationReducer(state: UserConfigurationState, action: Action) {
  return reducer(state, action);
}
